class Filters {
  constructor() {
    this.links = document.querySelectorAll('.collection-filters-symbolism__link');
    this.images = document.querySelectorAll('.collection-filters-symbolism__image');
  }

  imageHoverSymbolism() {
    this.links.forEach((link, index) => {
      link.addEventListener('mouseover', () => {
        this.images[index]?.classList.add('show', 'fade');
      });

      link.addEventListener('mouseout', () => {
        this.images[index]?.classList.remove('show', 'fade');
      });
    });
  }
}

const filters = new Filters();
filters.imageHoverSymbolism();
